import styled from "styled-components";
import { COLORS, TEXT_COLORS } from "../../../constants/design/colors";
import { COMPONENTS, SPACING } from "../../../constants/design/spacing";

// Critical liquidation-risk bar. Solid negative red (#FC0A52) with white text,
// per DESIGN.md (no glow/gradient/motion on the bar itself). Rendered in normal
// flow at the top of the app shell so it pushes content down rather than
// overlapping it.
export const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${SPACING.two}px;
  width: 100%;
  min-height: ${COMPONENTS.banner}px;
  padding: ${SPACING.one}px ${SPACING.three}px;
  background: ${COLORS.negative.one};
  color: ${TEXT_COLORS.one};
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  position: relative;
  z-index: 5;
  font-feature-settings: "tnum";

  > svg {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    stroke: ${TEXT_COLORS.one};
  }
`;

export const AddMarginButton = styled.button`
  flex-shrink: 0;
  margin-left: ${SPACING.two}px;
  padding: ${SPACING.one}px ${SPACING.two}px;
  border: 1px solid ${TEXT_COLORS.one};
  border-radius: 4px;
  background: transparent;
  color: ${TEXT_COLORS.one};
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: 0.15s all ease-in-out;

  &:hover {
    background: ${TEXT_COLORS.one};
    color: ${COLORS.negative.one};
  }
`;
